// @flow
import React from 'react';
import {
  Button,
  ComboBoxInput,
  Text,
  TextInput,
  SidebarSection,
  type ComboBoxOptions,
  NotificationMessage,
} from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import styled from 'styled-components';
import { format } from 'date-fns';

// $FlowFixMe - TS file
import DataEntryFields from './DataEntryFields';

const JournalEntryFormLayout = styled.div`
  display: grid;
  grid-template-rows: 1fr min-content;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

const FormFields = styled.div`
  overflow: auto;
`;

const FormActions = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  column-gap: 16px;
  padding: 8px 24px;
  background-color: ${colors.pearl};
`;

const FormGroup = styled.div`
  display: grid;
  grid-template-columns: 66px 1fr;
  grid-row-gap: 4px;
  align-items: center;
`;

const DataEntryFieldsWrapper = styled.div`
  padding-top: 24px;
`;

type JournalEntryFormProps = {
  addOnOptions: ComboBoxOptions,
  dataEntriesErrorMessage: string,
  defaultAddOnId: string,
  defaultDataEntries: Array<any>,
  defaultDateOfTransaction: string,
  defaultVendorName: string,
  isSubmitting: boolean,
  ledgerOptions: ComboBoxOptions,
  onCancel: () => void,
};

const JournalEntryForm = ({
  addOnOptions,
  dataEntriesErrorMessage,
  defaultAddOnId,
  defaultDataEntries,
  defaultDateOfTransaction,
  defaultVendorName,
  isSubmitting,
  ledgerOptions,
  onCancel,
  ...props
}: JournalEntryFormProps) => (
  <form {...props}>
    <JournalEntryFormLayout>
      <FormFields>
        <SidebarSection>
          <FormGroup>
            <Text color={colors.cloud} styleType="small" uppercase>
              Name
            </Text>
            <TextInput
              defaultValue={defaultVendorName.trim()}
              maxLength="2500"
              name="vendorName"
              required
              type="text"
            />
            <Text color={colors.cloud} styleType="small" uppercase>
              Date
            </Text>
            <TextInput
              defaultValue={defaultDateOfTransaction}
              min="2000-01-01"
              max={format(new Date(), 'YYYY-MM-DD')}
              name="dateOfTransaction"
              required
              type="date"
            />
            <Text color={colors.cloud} styleType="small" uppercase>
              Add-On
            </Text>
            <ComboBoxInput
              defaultValue={addOnOptions.find(option => option.value === defaultAddOnId)}
              name="addOnId"
              options={addOnOptions}
              isSearchable
              isClearable
              backspaceRemovesValue={false}
            />
          </FormGroup>
          <DataEntryFieldsWrapper>
            <DataEntryFields
              defaultDataEntries={defaultDataEntries}
              ledgerOptions={ledgerOptions}
            />
            {dataEntriesErrorMessage && (
              <NotificationMessage styleType="error">{dataEntriesErrorMessage}</NotificationMessage>
            )}
          </DataEntryFieldsWrapper>
        </SidebarSection>
      </FormFields>
      <FormActions>
        <Button
          data-heap-id="je-sidebar-edit-cancel"
          disabled={isSubmitting}
          size="large"
          styleType="ghost"
          type="button"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          data-heap-id="je-sidebar-edit-save"
          disabled={isSubmitting}
          size="large"
          styleType="primary"
          type="submit"
        >
          Save
        </Button>
      </FormActions>
    </JournalEntryFormLayout>
  </form>
);

JournalEntryForm.defaultProps = {};

export default JournalEntryForm;
